import React from 'react';
import { Link } from 'react-router-dom';

export default function StudentsDocs({ topic, setTopic, schoolType }) {
	const validTopics = ['search_students', 'upload_students', 'sort_students', 'add_student', 'edit_student', 'select_rows', 'delete_students', 'load_more_students'];
	const studentsTopic = validTopics.includes(topic) ? topic : 'default';

	const chooseStudentsTopic = (newTopic) => {
		if (studentsTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}
	};

	const videoPlaceholder = { backgroundColor: '#000', borderRadius: '8px', color: '#fff', minHeight: '240px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px', padding: '20px', textAlign: 'center' };

	return (
		<div className='documentation-page'>
			<div className='step-main-heading'>Students</div>
			<p className='documentation-question-heading'>What do you need help with?</p>
			<div className='choose-topic'>
				<Link className={`choose-topic-btn ${studentsTopic === 'search_students' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/students/${studentsTopic === 'search_students' ? 'null' : 'search_students'}`} onClick={() => chooseStudentsTopic('search_students')}>Search Students</Link>
				<Link className={`choose-topic-btn ${studentsTopic === 'upload_students' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/students/${studentsTopic === 'upload_students' ? 'null' : 'upload_students'}`} onClick={() => chooseStudentsTopic('upload_students')}>Upload Students</Link>
				<Link className={`choose-topic-btn ${studentsTopic === 'sort_students' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/students/${studentsTopic === 'sort_students' ? 'null' : 'sort_students'}`} onClick={() => chooseStudentsTopic('sort_students')}>Sort Student Data</Link>
				<Link className={`choose-topic-btn ${studentsTopic === 'add_student' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/students/${studentsTopic === 'add_student' ? 'null' : 'add_student'}`} onClick={() => chooseStudentsTopic('add_student')}>Add A Student</Link>
				<Link className={`choose-topic-btn ${studentsTopic === 'edit_student' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/students/${studentsTopic === 'edit_student' ? 'null' : 'edit_student'}`} onClick={() => chooseStudentsTopic('edit_student')}>Edit A Student</Link>
				<Link className={`choose-topic-btn ${studentsTopic === 'select_rows' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/students/${studentsTopic === 'select_rows' ? 'null' : 'select_rows'}`} onClick={() => chooseStudentsTopic('select_rows')}>Select Student Rows</Link>
				<Link className={`choose-topic-btn ${studentsTopic === 'delete_students' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/students/${studentsTopic === 'delete_students' ? 'null' : 'delete_students'}`} onClick={() => chooseStudentsTopic('delete_students')}>Delete Students</Link>
				<Link className={`choose-topic-btn ${studentsTopic === 'load_more_students' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/students/${studentsTopic === 'load_more_students' ? 'null' : 'load_more_students'}`} onClick={() => chooseStudentsTopic('load_more_students')}>Load More Students</Link>
			</div>

			{studentsTopic === 'search_students' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Search Students</h2>
					<div className='documentation-step-text'>Use the search bar to find students by last name, first name, or student code.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{studentsTopic === 'upload_students' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Upload Students</h2>
					<div className='documentation-step-text'>Use the Upload button to import student data with the upload modal.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{studentsTopic === 'sort_students' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Sort Student Data</h2>
					<div className='documentation-step-text'>Sort by Last Name, First Name, Grade, or Gender from the column headers.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{studentsTopic === 'add_student' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Add A Student</h2>
					<div className='documentation-step-text'>Click the plus button in the header row to create a new student.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{studentsTopic === 'edit_student' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Edit A Student</h2>
					<div className='documentation-step-text'>Click the edit icon on a row to open and update a student record.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{studentsTopic === 'select_rows' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Select Student Rows</h2>
					<div className='documentation-step-text'>Select one or many students, or use Select All for bulk actions.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{studentsTopic === 'delete_students' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Delete Students</h2>
					<div className='documentation-step-text'>Delete one or many selected students with confirmation and optional prompt suppression.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{studentsTopic === 'load_more_students' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Load More Students</h2>
					<div className='documentation-step-text'>Use Load More Students to reveal additional rows in increments of 50.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
		</div>
	);
}
